// extracted by mini-css-extract-plugin
export var anchor = "_33-0";
export var discard = "_33-4";
export var muiTooltipTooltip = "_33-6";
export var notificationBar = "_33-3";
export var saveButtonHoverSlotWrapper = "_33-5";
export var show = "_33-2";
export var spacer = "_33-1";